import { CacheRequestConfig } from 'axios-cache-interceptor';
import axiosInstance from './axios';
import { FilterComment, FilterConfig, SavedClipFilter } from '../components/ClipFilter/types';

export const getClipFilterComments = (feedId: string) => {
  const config: CacheRequestConfig = { cache: false };
  return axiosInstance.get<FilterComment[]>(`videofeed/${feedId}/clip-filter-comments`, config);
};

export const getSavedClipFilters = () => {
  const config: CacheRequestConfig = { cache: false };
  return axiosInstance.get<SavedClipFilter[]>('clip-filters', config);
};

export const saveClipFilter = (name: string, config: FilterConfig) =>
  axiosInstance.post<SavedClipFilter>('clip-filters', { name, config });

export const deleteClipFilter = (id: string | number) =>
  axiosInstance.delete(`clip-filters/${id}`);
